import React from 'react';
import {LayoutSidebar} from '../../../Layout';
import {AgencyPortalUsageContent} from './AgencyPortalUsageContent';

/**
 * Pantalla "Portal de clientes" (`/agency/portal-usage`).
 *
 * Shell mínimo, patrón del repo: `LayoutSidebar` bifurca solo entre el marco clásico y el de la
 * UX 2.1, así que la pantalla entra a los dos sin tocar nada. El contenido no depende del marco —
 * el ranking es de agencia y se sirve a cualquiera que tenga el portal en su plan.
 */
export function AgencyPortalUsage() {
    return (
        <div className="app-content">
            <LayoutSidebar/>
            <AgencyPortalUsageContent/>
        </div>
    );
}

export default AgencyPortalUsage;
